import { Router } from '@angular/router';
import { Auth } from './../../autentication/Auth';
import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { UserAdminService } from './user-admin.service';
import { UserList } from './models/user-list';
import { FormGroup } from '@angular/forms';
import { SharedService } from '../../shared/shared.service';

@Component({
	selector: 'app-user-admin',
	templateUrl: './user-admin.component.html',
	styleUrls: ['./user-admin.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class UserAdminComponent implements OnInit {

	confirmMessage: string;
	confirmType: string;

	constructor(private userAdminService: UserAdminService,
							private router: Router) { }

	ngOnInit() {
		if (Auth.getInstance().getUser().rule !== 'TRANSACIONAR') {
			this.router.navigate(['']);
		}
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/user-admin/user-admin.component.ts